"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { Play } from "lucide-react";
import { useState } from "react";
import YouTubePlayer from "~/components/job-page/jobadvideo/youtube-eon";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import type { TranslationsMap } from "~/translations/loader/init";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
interface VideoConfig {
  thumbnail: string;
  title: string;
  videoId: string;
}
const VIDEO_KEY_BY_TEMPLATE: Record<string, string | null> = {
  "HUN_General 1": "general1",
  "HUN_General 2": "general2",
  HUN_Engineer: "engineer",
  HUN_Electrician: "electrician",
  "HUN_Customer Service": "customerService",
  HUN_Manager: "manager",
  HUN_Trainee: null
};
function getVideos(t: TranslationsMap, template: string | undefined): VideoConfig[] {
  const key = template === undefined ? "default" : VIDEO_KEY_BY_TEMPLATE[template] ?? "default";
  if (!key) {
    return [];
  }
  const prefix = `hungary_expReports_${key}`;
  return [1, 2, 3].map(i => {
    const videoId = t[`${prefix}_videoID${i}` as keyof TranslationsMap] as string;
    return {
      title: t[`${prefix}_video${i}` as keyof TranslationsMap] as string,
      videoId,
      thumbnail: `images/videos/thumbnail/${videoId}.webp`
    };
  });
}
export default function ExperienceReportsEonHungary(t0) {
  const $ = _c(34);
  const {
    job
  } = t0;
  const t = useLanguage();
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  if (job.data.template === "HUN_Trainee" || job.data.entryLevel === "Trainee") {
    return null;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activeVideoIndex || $[1] !== job.data.template || $[2] !== t) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const videos = getVideos(t, job.data.template);
      if (videos.length === 0) {
        t9 = null;
        break bb0;
      }
      t7 = "w-full bg-gray-200 px-6 py-10 text-white md:px-10 md:py-20 print:hidden";
      t8 = "experienceReports";
      t5 = "mx-auto flex max-w-screen-xl flex-col";
      if ($[12] !== t.hungary_teaserBar_HL) {
        t6 = <h2 className="mb-12 w-full font-bold text-3xl text-primary md:text-4xl">{t.hungary_teaserBar_HL}</h2>;
        $[12] = t.hungary_teaserBar_HL;
        $[13] = t6;
      } else {
        t6 = $[13];
      }
      t3 = "grid auto-cols-[2.1fr_1fr] items-stretch gap-4 lg:grid-flow-col";
      t4 = <YouTubePlayer thumbnailSrc={videos[activeVideoIndex].thumbnail} videoId={videos[activeVideoIndex].videoId} />;
      t1 = "grid auto-rows-fr gap-4";
      let t10;
      if ($[14] !== activeVideoIndex) {
        t10 = (video, index) => index !== activeVideoIndex && <OtherVideo key={index} onVideoChange={() => setActiveVideoIndex(index)} video={video} />;
        $[14] = activeVideoIndex;
        $[15] = t10;
      } else {
        t10 = $[15];
      }
      t2 = videos.map(t10);
    }
    $[0] = activeVideoIndex;
    $[1] = job.data.template;
    $[2] = t;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t2) {
    t10 = <div className={t1}>{t2}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3 || $[21] !== t4) {
    t11 = <div className={t3}>{t4}{t10}</div>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t4;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== job) {
    t12 = <div className="mt-8 text-lg md:self-end"><ApplyButton className="w-full rounded-lg bg-white text-center font-bold text-primary transition-colors duration-150 hover:bg-primary hover:text-white" job={job} /></div>;
    $[23] = job;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t5 || $[28] !== t6) {
    t13 = <div className={t5}>{t6}{t11}{t12}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t5;
    $[28] = t6;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t7 || $[32] !== t8) {
    t14 = <div className={t7} id={t8}>{t13}</div>;
    $[30] = t13;
    $[31] = t7;
    $[32] = t8;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}
function OtherVideo(t0) {
  const $ = _c(9);
  const {
    video,
    onVideoChange
  } = t0;
  let t1;
  if ($[0] !== video.thumbnail || $[1] !== video.title) {
    t1 = <CustomImage alt={video.title} className="aspect-video h-full object-cover" height={480} src={video.thumbnail} width={640} />;
    $[0] = video.thumbnail;
    $[1] = video.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="playButton absolute top-1/2 left-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-2xl bg-white text-clientFont opacity-50 transition-all duration-300"><Play className="translate-x-px" size={20} /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="relative h-full w-full">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onVideoChange || $[7] !== t3) {
    t4 = <button className="grid h-full w-full auto-cols-[2fr_1fr] grid-flow-col transition-all duration-300 hover:scale-[1.02] [&_*]:hover:opacity-100" onClick={onVideoChange} type="button">{t3}</button>;
    $[6] = onVideoChange;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}